import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { ProductSortimentEntryPricingResponse } from '@app/api/marketplace/models';

@Component({
  selector: 'app-pricing-product-table',
  templateUrl: './pricing-product-table.component.html',
  styleUrls: ['./pricing-product-table.component.scss'],
})
export class PricingProductTableComponent {
  @Input() packagingUnitName!: string;
  @Input() label!: string;
  @Input() dataSource!: ProductSortimentEntryPricingResponse[];
  group!: UntypedFormGroup;

  priceColumns = [
    'manufacturerOrImporterPrice',
    'wholesalerPrice',
    'retailerPrice',
    'endConsumerPrice',
  ];
  displayedColumns = ['siteName', ...this.priceColumns];
}
